
import { Component, Prop, Vue } from 'vue-property-decorator'
import HomeNewsSwipper from './HomeNewsSwipper.vue'
import HomeNewsTrends from './HomeNewsTrends.vue'
import HomeInfos from './HomeInfos.vue'
import { NewsMixinManager } from './news-mixin/manager'
import { NewsMixinService } from './news-mixin/service'

@Component({
  components: {
    HomeNewsSwipper,
    HomeNewsTrends,
    HomeInfos
  }
})
export default class extends Vue {
  private manager = new NewsMixinManager(0, '', new NewsMixinService())
  private id = '77'
  private infoModules = [
    { id: '22', type: 'law', title: '公告', infos: [] },
    { id: '21', type: 'technology', title: '技术工作', infos: [] },
    { id: '3', type: 'org', title: '协会工作区' }
  ]

  mounted () {
    this.infoModules.map((item: any) => {
      console.log(item.id)
      this.manager.getInfomation(item)
    })
    this.manager.getNewsInfomation(this.id)
  }

  jumpDetail (item: any) {
    window.location.href = (`infoNews.html#/news/${item.id}/${'0'}`)
  }
}
